/* eslint-disable no-nested-ternary */
import { Grid, IconButton, MenuItem } from '@material-ui/core';
import { ChevronLeft, Group, Visibility } from '@material-ui/icons';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import {
  getContractTypes,
  getStudentAffiliate,
  getStudentOnBusinessTeam,
  getStudentOnTeam,
  getTrainingById,
  setTeamMemberAction,
} from '@webapps/business';
import {
  Button,
  Modal,
  ModalSideBar,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeadCell,
  TableHeadRow,
  TableRow,
  TextField,
  TextFieldPx,
  useAuth,
  useMutation,
  useQuery,
  useRouter,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import AvatarStudent from 'components/Avatar/AvatarStudent';
import ModalConfirm from 'components/ModalConfirm/ModalConfirm';
import ProfilSidebar from 'components/ProfilSidebar';
import ProfilName from 'components/ProfilSidebar/Components/ProfilName';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import CandidatsCard from './CandidatsCard';
import Team from 'components/Icons/Team';

const StudentHistoriqueBusiness = () => {
  const {
    classes,
    css,
    theme: { spacing },
  } = useStyles(styles);

  const { params } = useRouter();
  const { idUser } = useAuth();
  // const { id: idParam } = params;
  const idParam = idUser
  const [page, setPage] = useState(1);
  const [keyword, setKeyword] = useState('ABANDONED, EXCLUDED');

  const {
    // status: load,
    data: { content: infoMembers = [], totalElements } = {},
    refetch,
    // isFetching,
  } = useQuery(getStudentOnBusinessTeam, {
    key: ['studentsBusinessTeamEXCLUDED', page + idParam + keyword],
    variables: {
      keyword,
      id: idParam,
      status: keyword,
      page: page - 1,
      size: 8,
    },
    keepPreviousData: true,
    staleTime: 5000,
  });

  const handlePaginationChange = (newPage) => {
    setPage(newPage);
  };

  const goToPreviousPage = () => {
    window.history.back();
  };

  const searchStudentList = (e) => {
    if (e.target.value) {
      setKeyword(e.target.value);
      setPage(1);
    }
  };

  return (
    <div className={classes.container}>
      <Grid container >
        <Grid item xs={12}>
          <div className={classes.containerSearch}>
            <Grid container style={{ display: 'flex', flexDirection: 'column' }}>
              <Grid container style={{ display: 'flex', gap: '10px' }}>
                <Grid xs={12} md={1}>
                  <Button
                    className={classes.returnButton}
                    onClick={goToPreviousPage}
                    startIcon={<ChevronLeft />}
                  >
                    Retour
                  </Button>
                </Grid>
                <Grid
                  className={css({
                    marginBottom: spacing(2),
                    '@media (max-width:768px)': { marginTop: spacing(0) }
                  })}
                  item
                  xs={12} md={3}
                >
                  <TextField
                    fullWidth
                    label="Type de sortie"
                    name="list"
                    borderRadius={30}
                    onChange={(e) => searchStudentList(e)}
                    select
                    variant='outlined'
                    value={keyword}
                  >
                    <MenuItem value="ABANDONED, EXCLUDED" >Tous les apprenants</MenuItem>
                    <MenuItem value="EXCLUDED" >Apprenants exclus</MenuItem>
                    <MenuItem value="ABANDONED" >Apprenants ayant quitté l’équipe</MenuItem>
                  </TextField>
                </Grid>
              </Grid>
              {!infoMembers?.length ? (
                <Grid
                  className={css({
                    textAlign: 'center',
                    color: '#5D75A8',
                    backgroundColor: '#F3F7FF',
                    borderRadius: 10,
                    padding: spacing(2.5)
                  })}
                >
                  <FormattedMessage id="noElements" />
                </Grid>
              ) : (
                <Grid container style={{ backgroundColor: '#F3F7FF', borderRadius: 10, padding: spacing(0, 0, 2.5, 2.5), marginBottom: spacing(2.5) }}>
                  {infoMembers?.map((item, index) => (
                    <CandidatsCard item={item} />
                  ))}
                </Grid>
              )}
            </Grid>
          </div>
        </Grid>
      </Grid>
      <Pagination
        onChange={handlePaginationChange}
        page={page}
        pageCount={8}
        totalCount={totalElements}
      />
    </div>
  );
};



const styles = ({ spacing }) => ({
  container: {
    height: '100%',
    padding: '50px',
    '@media only screen and (max-width:1543px)': { padding: '42px' },
    '@media only screen and (max-width:1440px)': { padding: '34px' },
    minHeight: '100vh',

    '@media only screen and (max-width:768px)': { padding: spacing(2) },
  },
  paper: {
    padding: spacing(2.5),
  },
  infoCandidat: { display: 'flex' },
  tableHead: {
    '&.MuiTableCell-head': {
      color: 'white',
      width: 350,
      maxWidth: '100%',
    },
  },
  containerSearch: {
    background: 'white',
    padding: spacing(2.5),
    borderRadius: 10,
  },
  title: {
    margin: 0,
    flex: 1,
  },
  searchContainer: {
    marginTop: spacing(2),

    display: 'flex',
    justifyContent: 'space-between',
  },
  returnButton: {
    color: '#5A6DA1',
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' }, '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    border: '1px solid #C0D9FF',
    backgroundColor: 'white',
    borderRadius: '20px',
    fontWeight: 600,
    width: '100%',
    '@media (max-width:768px)': { marginTop: spacing(2.5), },
  },
});

export default StudentHistoriqueBusiness;
